import { InfoWithBulletPoints } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import LazyLoadMedia from 'app/helpers/LazyLoadMedia'

export interface IAttributes extends React.ComponentProps<typeof InfoWithBulletPoints> {
  ctaText: string
  ctaUrl: string
  ctaTarget: string
  ctaRel: string
  ctaClassName: string
  mediaUrl: string
  points: string[]
}

const InfoWithBulletPointsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const callToAction = attributes.ctaText
    ? {
        text: attributes.ctaText,
        url: attributes.ctaUrl,
        target: attributes.ctaTarget,
        rel: attributes.ctaRel,
        className: attributes.ctaClassName,
      }
    : undefined
  const mediaUrl = attributes.mediaUrl

  return (
    <InfoWithBulletPoints
      title={attributes.title}
      image={<LazyLoadMedia mediaUrl={mediaUrl} />}
      background={attributes.background}
      reverse={attributes.reverse}
      callToAction={callToAction}
      trustpilot={attributes.trustpilot}
      label={attributes.label}
      points={attributes.points.map((point) => parse(point ?? ''))}
      honeygainLogo={attributes.honeygainLogo}
      sublabel={attributes.sublabel}
    />
  )
}

export default InfoWithBulletPointsBlock
